export const environment = {
    production: true,
    appVersion: require('../../package.json').version,

    adal: {
        tenant: 'd6caa1fc-dfee-4c76-84b3-80b9308aa91e',
        clientId: '108a84fb-4691-444f-abf9-2487978cd677',
        customScope: 'https://webapp-api.benelynk.com/standard-access'
    },
    allowEnrollment: false,
    allowEligibility: true,
    activePreviewFeature: true, // As Chris suggestion the feature preview is always active

    appInsights: {
        buildNumber: '20260106.1'
    }
};
